import { useTranslation } from '../../hooks/useTranslation'
import { amountCurrency } from '../../lib/format'
import Overlay, { amountClass, headlineClass, subClass } from './Overlay'

export default function ChangeOverlay({
  kind,
  amount,
  currency,
}: {
  kind: 'change' | 'cashback'
  amount: number
  currency: string
}) {
  const { t, locale } = useTranslation()
  const headline = kind === 'change' ? 'your-change' : 'your-cashback'
  const sub = kind === 'change' ? 'collect-your-change' : 'collect-your-cashback'

  return (
    <Overlay icon="↩" iconClass="bg-accent/[0.12] text-accent border-accent/30">
      <div className={headlineClass}>{t(headline)}</div>
      <div className={subClass}>{t(sub)}</div>
      <div className={amountClass}>{amountCurrency(amount, currency, locale)}</div>
      <div className="pulse-gold mt-[clamp(10px,2vh,22px)] h-2.5 w-2.5 rounded-full bg-accent" />
    </Overlay>
  )
}
